module.exports = __webpack_public_path__ + "static/img/gerenhuli.917e718.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/gerenhuli.png
// module id = oKDK
// module chunks = 0